// src/PrivacyPage.js
import * as React from "react";
import { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

export const PrivacyPage = () => {
    const navigate = useNavigate();
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch('/privacy.md')
            .then((r) => r.text())
            .then((text) => { setContent(text); setLoading(false); })
            .catch(() => { setContent('Eroare la încărcarea politicii de confidențialitate.'); setLoading(false); });
    }, []);

    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', mt: 4, mb: 8, px: 3 }}>
            <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)} sx={{ mb: 3 }}>
                Înapoi
            </Button>

            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
                    <CircularProgress />
                </Box>
            ) : (
                <Box sx={{
                    '& h1': { fontSize: '2rem', fontWeight: 700, mb: 1 },
                    '& h2': { fontSize: '1.2rem', fontWeight: 600, mt: 3, mb: 1 },
                    '& p':  { mb: 1.5, lineHeight: 1.7 },
                    '& ul': { pl: 3, mb: 1.5 },
                    '& li': { mb: 0.5 },
                    '& hr': { my: 3, borderColor: 'divider' },
                    '& a':  { color: 'primary.main' },
                    '& em': { color: 'text.secondary', fontSize: '0.875rem' },
                }}>
                    <ReactMarkdown>{content}</ReactMarkdown>
                </Box>
            )}
        </Box>
    );
};
